import React from 'react';
import PropTypes from 'prop-types';
import { LinearProgress, Typography } from '@mui/material';
import { OnyxBanner } from './OnyxBanner';

/**
 * Multi-step wizard / clinic runner shell.
 */
export function OnyxWizardShell({
  title,
  stepLabel,
  progress = null,
  banner = null,
  bannerSeverity = 'info',
  children,
  footer = null,
  className = '',
}) {
  const progressValue = typeof progress === 'number'
    ? Math.max(0, Math.min(100, progress))
    : null;

  return (
    <div
      className={['onyx-wizard-shell', className].filter(Boolean).join(' ')}
      data-testid="onyx-wizard-shell"
    >
      <header className="onyx-wizard-shell__header">
        {title ? (
          <Typography variant="h4" component="h1">{title}</Typography>
        ) : null}
        {stepLabel ? (
          <Typography variant="label" component="p" className="onyx-wizard-shell__step">
            {stepLabel}
          </Typography>
        ) : null}
        {progressValue !== null ? (
          <LinearProgress
            variant="determinate"
            value={progressValue}
            className="onyx-wizard-shell__progress"
          />
        ) : null}
      </header>
      {banner ? (
        <div className="onyx-wizard-shell__banner">
          <OnyxBanner severity={bannerSeverity}>{banner}</OnyxBanner>
        </div>
      ) : null}
      <div className="onyx-wizard-shell__body">{children}</div>
      {footer ? <footer className="onyx-wizard-shell__footer">{footer}</footer> : null}
    </div>
  );
}

OnyxWizardShell.propTypes = {
  title: PropTypes.node,
  stepLabel: PropTypes.node,
  progress: PropTypes.number,
  banner: PropTypes.node,
  bannerSeverity: PropTypes.oneOf(['info', 'success', 'warning', 'error']),
  children: PropTypes.node,
  footer: PropTypes.node,
  className: PropTypes.string,
};
